export const GAP_WIDTH = 120
export const BORDER_ADJUSTMENT = 2
export const LINE_GAP = GAP_WIDTH - BORDER_ADJUSTMENT
export const LINE_SPACING = 8
export const LINE_RATIO = 8
export const PUSH_LINE_DOWN = 14
export const PUSH_LINE_UP = -11
export const CURVE_WIDTH = 4
